import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';

import { setOrtActive } from '../actions/actions';
import ToggleButton from './ToggleButton';
import SwipeActions from './SwipeActions';

const Ort = props => (
  <SwipeActions ortId={props.ort.subscriptionId}>
    <div className="Ort">
      <ToggleButton
        name={props.ort.name}
        onToggle={value => props.setOrtActive(props.ort.name, value)}
        defaultChecked={props.ort.active}
      />
      <RouterLink to={`/orte/${props.ort.name}`} className="Ort-link">
        <div className="Ort-text">
          <b>{props.ort.name}</b> + {props.ort.radius}km
        </div>
        <img className="Ort-more" src="/images/arrow.png" alt={`${props.ort.name} bearbeiten`} />
      </RouterLink>
    </div>
  </SwipeActions>
);

Ort.propTypes = {
  setOrtActive: PropTypes.func.isRequired,
  ort: PropTypes.object.isRequired,
};

const mapDispatchToProps = dispatch => ({
  setOrtActive: (name, value) => {
    dispatch(setOrtActive(name, value));
  },
});

export default connect(null, mapDispatchToProps)(Ort);



// WEBPACK FOOTER //
// ./src/js/components/Ort.js